import { createPaymentLink, getBillingPacks, type GeniPack } from "@/api/billing";
import { ref } from "vue";

const packs = ref<GeniPack[]>([]);
const isLoadingPacks = ref(false);
const isPaying = ref(false);

export function useBilling() {
  async function ensurePacksLoaded(): Promise<void> {
    if (packs.value.length > 0 || isLoadingPacks.value) return;
    isLoadingPacks.value = true;
    try {
      packs.value = await getBillingPacks();
    } finally {
      isLoadingPacks.value = false;
    }
  }

  async function topUp(packId: string): Promise<void> {
    if (isPaying.value) return;
    isPaying.value = true;
    try {
      const payment = await createPaymentLink(packId);
      if (!payment.paymentUrl) {
        throw new Error("Не удалось получить ссылку на оплату");
      }
      if (typeof window !== "undefined") {
        window.location.assign(payment.paymentUrl);
      }
    } finally {
      isPaying.value = false;
    }
  }

  return {
    packs,
    isLoadingPacks,
    isPaying,
    ensurePacksLoaded,
    topUp,
  };
}
